import { FetchWithAuth } from "./apiService";

export async function getTags(auth, hidden = null) {
	let url = "tags";
	if (hidden !== null) url += `?hidden=${hidden ? 1 : 0}`;
	return FetchWithAuth(auth, url);
}

export async function getTagsById(auth, id) {
	return FetchWithAuth(auth, "tags/" + id);
}

export async function updateTag(auth, id, tag, hex_color, hidden) {
	const body = {};
	if (tag !== undefined) body.tag = tag;
	if (hex_color !== undefined) body.hex_color = hex_color;
	if (hidden !== undefined) body.hidden = hidden; // boolean o 0/1
	return FetchWithAuth(auth, "tags/" + id, body, { method: "PUT" });
}

export async function deleteTag(auth, id) {
	return FetchWithAuth(auth, "tags/" + id, null, { method: "DELETE" });
}

export async function createTag(auth, tag, hex_color, hidden = false) {
	return FetchWithAuth(auth, "tags", { tag, hex_color, hidden }, { method: "POST" });
}
